import styled from "styled-components";

export const Video = styled.main`
  & > div {
    display: grid;
  }

  iframe {
    width: 100%;
    height: 300px
  }

  h1 {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 24px;
    color: #222;
    margin-bottom: 40px;
  }
`;
